import React from 'react';
import { UserContext } from '../../../../shared/authentication';
import { Link } from '../../../../shared/components';
import GlobalizedText from '../../../../shared/globalization';
import { $, getFromStorage, removeFromStorage, win } from '../../../../shared/utils';
import logo from './images/logo1.svg';
import Menu from './menu';
import { updateRegButtonState } from '../../../../themes/blue/header';
function SSOButton(props: any) {
    if (props.user !== null) {
        return <></>;
    }
    return <a href={`http://${win.location.host}/saml2/init/simplesamllocal`} className="btn-utility btn-uti-l">SAML2</a>;
}
function SSOButton1(props: any) {
    if (props.user !== null) {
        return <></>;
    }
    return <a href={`http://${win.location.host}/openidconnect/init`} className="btn-utility btn-uti-l">OpenID</a>;
}
function LoginButton(props: any) {
    if (props.user !== null) {
        return <></>;
    }
    return <Link to="/login" forceRefresh={true} className="btn-utility btn-uti-l"><GlobalizedText message="common.lbl.login" /></Link>;
}
function LogoutButton(props: any) {
    const config = getFromStorage('gwp.config', true);
    if (props.user === null) {
        return <></>;
    }
    if(config.openIdConnect === false){
        return <Link to="/login" onClick={() => {
            removeFromStorage('_csrf');
            props.userService.signout();
            if(config.openIdConnect === false){
                updateRegButtonState((showButton: boolean) => {
                    props.setShowRegistrationButton(showButton);
                });
            }
        }} className="btn-utility btn-uti-l"><GlobalizedText message="common.lbl.logout" /></Link>;
    }else{
        return <a href="javascript:void(0);" onClick={() => {
            removeFromStorage('_csrf');
            props.userService.signout(props.user.proxyUser);
        }} className="btn-utility btn-uti-l"><GlobalizedText message="common.lbl.logout" /></a>;
    }
}
function RegistrationButton(props: any) {
    if (props.user !== null) {
        return <></>;
    }
    return <Link to={"/registration"} forceRefresh={true} className="btn-utility btn-uti-l"><span><GlobalizedText message="login.lbl.signup" /></span></Link>;
}

function Name(props: any) {
    if (props.user === null) {
        return <></>;
    }
	return <a href={'#'} className="u-split">{props.user.firstName} {props.user.lastName}</a>;
// for PGL, with SSO Enabled we do not want to allow access to change myprofile page   return <Link to="/myprofile" className="u-split">{props.user.firstName} {props.user.lastName}</Link>
}

function Search(props: any) {
    return <></>

}

export function Header(props: any) {
    return (
        <header className="gwp-header">
            <div className="gwp-header-logobar">
                <div className="container ">
                    <div className="navbar-uptop">
                        <div className="nav-container">
                            <div className="navbar-logo">
                                <a rel="noopener noreferrer" ><img src={logo} /></a>
                            </div>
                             <div className="navbar-utility"> 
                                <UserContext.Consumer>
                                    {user => (
                                        <Name user={user} />
                                    )}
                                </UserContext.Consumer>
                                <UserContext.Consumer>
                                    {user => (
                                        <React.Fragment>
                                            {
                                             /*   <> <SSOButton user={user} />
                                                    <SSOButton1 user={user} />
                                                </>  */
                                            }
                                            <LoginButton user={user} userService={props.userService} />
                                            <LogoutButton user={user} userService={props.userService} />
                                            <RegistrationButton user={user} />
                                        </React.Fragment>
                                    )}
                                </UserContext.Consumer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="container gwp-header-menubar">
                <div className="gwp-header-menubar-header hidden-sm hidden-md hidden-lg">
                    <div className="row">
                        <div className="col-xs-9">
                            <Search />
                        </div>


                        <div className="col-xs-3">
                            <button type="button" className="navbar-toggle collapsed" onClick={() => { $("#navbar").collapse('toggle') }} aria-expanded="false" aria-controls="navbar">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                        </div>
                    </div>
                </div>

                <div id="navbar" className="collapse navbar-collapse gwp-header-menubar-body">
                    <div className="row">
                        <Menu breadcrumb={props.breadcrumb} config={props.config} />
                        <div className="col-md-4 col-sm-5 hidden-xs">
                            <Search />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}